const PowerIcon = () => (
  <svg width="14" height="17" viewBox="0 0 14 17" fill="none" xmlns="http://www.w3.org/2000/svg">
    <circle cx="7" cy="9.23999" r="6.5" stroke="black" />
    <rect x="3.91998" width="6.16" height="9.52" fill="white" />
    <path d="M6.99997 7.55999V2.51999" stroke="black" strokeLinecap="square" />
  </svg>
);

export default PowerIcon;
